import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Modal from '../../Modal/Modal';
import styles from './CreateGuildModal.module.scss';
import { Field, Form, Formik } from 'formik';
import TextInput from '../../Form/TextInput/TextInput';
import Button from '../../Button/Button';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import Heading from '../../Typography/Heading/Heading';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { clearData, resetErrors } from '../../../store/reducers/Guild/slice';
import SelectInput from '../../Form/SelectInput/SelectInput';
import TextError from '../../TextError/TextError';
import { firstLetterUpperCase } from '../../../helpers';
import Loader from '../../Loader/Loader';
import { validateImage } from '../../../helpers/validateImage';
import { GuildActionsName } from '../../../store/reducers/Guild/guildType';
import { checkname, createGuild, editGuild, getAllGuilds } from '../../../store/reducers/Guild/guildRequest';
import { useCreateGuildValidationSchema } from '../../../validations/createGuild';
import { useNavigate } from 'react-router-dom';
import PhotoSelect from '../../PhotoSelect/PhotoSelect';
import { ReactComponent as Logo } from '../../../assets/icons/logo.svg';
import MakePhotoIcon from '../../MakePhotoIcon/MakePhotoIcon';
import { useDebouncedCallback } from 'use-debounce';
var PrivacyType;
(function (PrivacyType) {
    PrivacyType["PRIVATE"] = "private";
    PrivacyType["OPEN"] = "open";
})(PrivacyType || (PrivacyType = {}));
export const COLLECTIONS = [
    {
        label: 'EquineNFT Profile Pictures',
        value: 'EquineNFT Profile Pictures',
        contents: [
            {
                id: 0,
                asset: Logo,
                value: 'logo'
            }
        ]
    }
];
const CreateGuildModal = ({ closeModal, text, isEdit, id }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const ref = useRef(null);
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [privacy, setPrivacy] = useState(PrivacyType.OPEN);
    const [showPhotoSelect, setShowPhotoSelect] = useState(false);
    const { error, pending, isDataSent, guildInfo, errorOnName } = useAppSelector((state) => state.guild);
    const createGuildValidationSchema = useCreateGuildValidationSchema();
    const privacyOption = [
        {
            value: PrivacyType.PRIVATE,
            label: t('private')
        },
        {
            value: PrivacyType.OPEN,
            label: t('open')
        }
    ];
    const handleClose = () => {
        dispatch(resetErrors());
        closeModal();
    };
    // useEffect(() => {
    //     if (searchUser === '') {
    //         dispatch(resetError());
    //         return;
    //     }
    //     const debounce = setTimeout(() => {
    //         dispatch(checkName(searchUser));
    //     }, 300);
    //     return () => clearTimeout(debounce);
    // }, [dispatch, searchUser]);
    const debounced = useDebouncedCallback((value) => dispatch(checkname({ name: value, id: id || null })), 300);
    const sendProfileInfo = async (e) => {
        var _a;
        e.preventDefault();
        const formData = new FormData();
        if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.files))
            return;
        const { files } = ref.current;
        validateImage(files[0])
            .then(() => {
            formData.append('image', files[0]);
            formRef.current = formData;
        })
            .catch(() => {
            // setBadFormatPhoto(true);
        });
    };
    const handleEditGuild = async (parsedData) => {
        await dispatch(editGuild({ id: id, form: parsedData, image: formRef.current }));
        dispatch(getAllGuilds(''));
    };
    useEffect(() => {
        if (!error && isDataSent.includes(GuildActionsName.CREATE_GUILD)) {
            navigate(`/social/guild/${guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.id}`);
            handleClose();
            dispatch(clearData(GuildActionsName.CREATE_GUILD));
        }
    }, [navigate, guildInfo, error, dispatch, closeModal, isDataSent]);
    const profileSelectBack = () => {
        setShowPhotoSelect(false);
    };
    const profileSelectSave = () => {
        setShowPhotoSelect(false);
    };
    useEffect(() => {
        if (guildInfo)
            setPrivacy(guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.privacy);
    }, [guildInfo]);
    return (_jsxs(Modal, Object.assign({ className: styles.element, closeModal: handleClose }, { children: [_jsx(Heading, { className: styles.heading, title: text }), _jsx(Formik, Object.assign({ initialValues: {
                    name: isEdit ? guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.name : '',
                    privacy: isEdit ? guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.privacy : PrivacyType.OPEN
                }, onSubmit: (values, { resetForm }) => {
                    const parsedData = {
                        name: values.name,
                        privacy: values.privacy
                    };
                    if (isEdit && id) {
                        return handleEditGuild(parsedData);
                    }
                    else {
                        dispatch(createGuild({ form: parsedData, image: formRef.current }));
                    }
                    resetForm();
                }, validationSchema: createGuildValidationSchema }, { children: ({ handleChange, setFieldValue, handleBlur, values, handleSubmit }) => (_jsxs(Form, Object.assign({ className: styles.form, onSubmit: (e) => {
                        handleSubmit();
                        return sendProfileInfo(e);
                    }, onChange: (e) => {
                        debounced(e.target.value);
                    } }, { children: [_jsxs("div", Object.assign({ className: cn(styles.photoSelect) }, { children: [_jsx("div", Object.assign({ className: styles.logo }, { children: _jsx(Logo, {}) })), _jsx("button", Object.assign({ type: "button", onClick: () => setShowPhotoSelect(true) }, { children: _jsx(MakePhotoIcon, {}) }))] })), _jsx(PhotoSelect, { isOpen: showPhotoSelect, forwardRef: ref, type: "guild", title: t('select_a_guild_profile_picture'), collections: COLLECTIONS, backHandler: profileSelectBack, saveHandler: profileSelectSave }), _jsx(Field, { label: t('guild_name'), className: "w-100", type: "text", onChange: handleChange, onBlur: handleBlur, name: "name", id: "name", value: values.name, defaultValue: values.name, component: TextInput }), errorOnName && (_jsx(TextError, { className: styles.errorText, text: errorOnName })), _jsx(Field, { label: t('privacy'), className: styles.privacy, type: "text", name: "privacy", value: values.privacy, onChange: (e) => {
                                setFieldValue('privacy', e.value);
                                setPrivacy(e.value);
                            }, options: privacyOption, component: SelectInput }), _jsx(Paragraph, { className: styles.desc, size: 1, color: 'grey', fontFamily: 'urbanist', title: privacy === PrivacyType.PRIVATE
                                ? t('user_will_be_able_to_join_your_approval_by_invitation')
                                : t('any_user_can_join_a_public_guild') }), pending.includes(GuildActionsName.CREATE_GUILD) ? (_jsx(Button, { className: cn('w-100'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { className: cn(styles.button, 'w-100'), height: 'sm', size: '100', type: 'submit', text: text })), error && _jsx(TextError, { text: firstLetterUpperCase(error) })] }))) }))] })));
};
export default CreateGuildModal;
